import { render, staticRenderFns } from "./notification-phone-note-list.vue?vue&type=template&id=1f3d44ab&"
import script from "./notification-phone-note-list.vue?vue&type=script&lang=js&"
export * from "./notification-phone-note-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports